import {
	AfterViewInit,
	Component,
	Inject,
	Optional,
	ChangeDetectionStrategy,
} from '@angular/core';
import {
	FormControl,
	FormGroup,
	Validators,
	ReactiveFormsModule,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { MatIcon } from '@angular/material/icon';
import {
	MatFormField,
	MatLabel,
	MatError,
	MatInput,
} from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgFor, NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-legal-fee-exception-modal',
	templateUrl: './legal-fee-exception-modal.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./legal-fee-exception-modal.component.scss'],
	imports: [
		MatIcon,
		ReactiveFormsModule,
		MatFormField,
		MatLabel,
		MatSelect,
		NgFor,
		MatOption,
		NgIf,
		MatError,
		MatInput,
		MatButton,
	],
})
export class LegalFeeExceptionModalComponent {
	constructor(
		private apiService: LegacyApiService,
		public dialogRef: MatDialogRef<LegalFeeExceptionModalComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any
	) {}
	request_form = new FormGroup({
		fileType: new FormControl('New', Validators.required),
		requestedAmount: new FormControl('', Validators.required),
		requestedReason: new FormControl('', Validators.required),
	});

	fileType = ['New', 'Refinance'];

	requestLegalWaiveOff() {
		const data = Object.assign({}, this.data, this.request_form.value, {
			waive_off_mode: 'Full',
		});
		this.apiService.updateSahaException(true, data).subscribe((res: any) => {
			if (res?.message == 'Success') {
				this.dialogRef.close(true);
			} else {
				console.log(res, 'Error submitting waive-off request.');
			}
		});
	}

	closeModal() {
		this.dialogRef.close(false);
	}
}
